import { Grid, TextField } from '@material-ui/core';
import CommonDialog from 'components/CommonDialog';
import React, { useState } from 'react';
import Dropdown from 'Views/FlexPayV2/common-components/Dropdown/Dropdown';
import PropTypes from 'prop-types';

const TerminalCrudPopup = ({
  open,
  onClose,
  onConfirm,
  mode,
  data,
  isLoading,
}) => {
  const [{ regisText, terminalName, status, id, index }, setTerminalData] =
    useState(() => ({
      regisText: '',
      terminalName: data?.terminalName || '',
      status: data?.status || 'Active',
      id: data?.id ?? '',
      index: data?.index ?? -1,
    }));

  const handleFieldChange = (componentKey, newValue) => {
    setTerminalData((prevState) => ({
      ...prevState,
      [componentKey]: newValue,
    }));
  };

  const onCrudConfirm = () => {
    onConfirm({
      regisText,
      terminalName,
      status,
      id,
      index,
    });
  };

  return (
    <CommonDialog
      open={true}
      maxWidth="sm"
      handleClose={onClose}
      dialogTitle={mode === 'EDIT' ? 'Edit Terminal' : 'Add Terminal'}
      primaryBtnTxt={mode === 'EDIT' ? 'Save Changes' : 'Add Terminal'}
      handlePrimaryButtonClick={onCrudConfirm}
      disabledPrimaryButton={
        isLoading || (!regisText && mode === 'ADD') || !terminalName
      }
      primaryButtonStyles={{ minWidth: 80 }}
      isLoading={isLoading}
      secondaryBtnTxt="Cancel"
      disableSecondaryButton={isLoading}
    >
      <Grid container justifyContent="space-between" spacing={4}>
        {mode !== 'EDIT' ? (
          <Grid item xs={12}>
            <TextFieldComponent
              label={'Registration Text'}
              required={true}
              value={regisText}
              componentKey={'regisText'}
              onChange={handleFieldChange}
            />
          </Grid>
        ) : (
          <></>
        )}
        <Grid item xs={6}>
          <TextFieldComponent
            label={'Terminal Name'}
            required={true}
            value={terminalName}
            componentKey={'terminalName'}
            onChange={handleFieldChange}
          />
        </Grid>
        <Grid item xs={6}>
          <Dropdown
            name="status"
            label="Status"
            value={status}
            listName="status"
            list={[
              { label: 'Active', status: 'Active' },
              { label: 'Inactive', status: 'Inactive' },
            ]}
            onChange={(_name, newStatus) =>
              handleFieldChange('status', newStatus)
            }
          />
        </Grid>
      </Grid>
    </CommonDialog>
  );
};

const TextFieldComponent = ({
  label,
  onChange,
  required,
  value,
  componentKey,
}) => {
  return (
    <TextField
      fullWidth
      required={required}
      label={label}
      value={value}
      onChange={(event) => onChange(componentKey, event.target.value)}
      variant="outlined"
      InputProps={{
        'data-testid': `terminal-registration-text`,
      }}
    />
  );
};

TextFieldComponent.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.string,
  componentKey: PropTypes.string,
};

export default TerminalCrudPopup;

TerminalCrudPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  mode: PropTypes.string,
  data: PropTypes.object,
  isLoading: PropTypes.bool,
};
